export default {
  EXCHANGE_RATE_UPDATE: 'EXCHANGE_RATE_UPDATE',
  SELECTED_CURRENCY_UPDATE: 'SELECTED_CURRENCY_UPDATE',
  DEFAULT_CURRENCIES_UPDATE: 'DEFAULT_CURRENCIES_UPDATE',
  SUPPORTED_CURRENCIES_LOADED: 'SUPPORTED_CURRENCIES_LOADED',
};
